import { loader } from 'graphql.macro'

export default async function exportClientToQbo ({ dataLoaders, variables }) {
  const schema = loader('./exportClientToQbo.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id
    }
  })
  return response.exportClientToQuickbooks
}
